@if (control) {
  <mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <mat-select
      [panelClass]="'app-ui-select' + ' ' + panelClass"
      [formControl]="control"
      [multiple]="isMultiple"
      [hideSingleSelectionIndicator]="true"
      (selectionChange)="onChange($event)"
      [value]="selected"
      [disabled]="disabled"
      [required]="required"
      [compareWith]="compareWith"
      (openedChange)="onPanelOpenedChange($event)"
    >
      <mat-select-trigger>
        @if (!isMultiple && control.value !== null && control.value !== undefined) {
          <span>
            {{ getSelectedOptionName(control.value) | translate }}
          </span>
        }
        @if (
          isMultiple &&
          control.value !== null &&
          control.value !== undefined &&
          control.value.length > 0
        ) {
          <span>
            {{ getMultipleSelectedOptionNames(control.value) }}
          </span>
        }
      </mat-select-trigger>
      @if (enableSearch) {
        <input
          #searchInput
          (keyup)="$event.stopPropagation(); onSearch($event)"
          (keydown)="$event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
          placeholder="{{ 'search' | translate }}"
          class="mat-dropdown-select-input"
        />
        @if (searchMode === 'api') {
          <div class="search-api-hint">{{ 'searchToRevealOrScrollDescription' | translate }}</div>
        }
      }
      @if (enableBlankOption && !isMultiple) {
        <mat-option></mat-option>
      }
      @if (selectAll) {
        <mat-optgroup class="select-all-checkbox-row-group divider-bottom">
          <mat-checkbox
            class="mat-option select-all-row"
            color="primary"
            [ngClass]="{ 'mat-selected': areSomeRowsSelected || areAllRowsSelected }"
            [indeterminate]="areSomeRowsSelected"
            [checked]="areAllRowsSelected"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection($event)"
          >
            {{ 'selectAll' | translate }}
          </mat-checkbox>
        </mat-optgroup>
      }
      @if (selectAllSingleChoice) {
        <mat-option
          class="mat-option select-all-row-single-choice"
          [value]="{ id: SELECT_ALL_VALUE }"
        >
          {{ 'all' | translate }}
        </mat-option>
      }
      @if (returnWholeObject) {
        <ng-container *ngTemplateOutlet="wholeObject"></ng-container>
      } @else {
        @if (returnData) {
          <ng-container *ngTemplateOutlet="valueData"></ng-container>
        } @else {
          @for (option of getDisplayedOptionsForRender(); track option.id + '-' + $index) {
            <mat-option
              [value]="option.id"
              [ngClass]="option.optionClass"
              [disabled]="option.isOptionDisabled"
            >
              <ng-container
                *ngTemplateOutlet="optionTemplate; context: { option: option }"
              ></ng-container>
            </mat-option>
          }
        }
      }
      <ng-template #optionTemplate let-option="option">
        <div
          [style.marginLeft.px]="option.indent * indent"
          [ngClass]="{ 'top-level-indent': !option.indent && hasIndent }"
        >
          @if (option.isFavorite) {
            <span class="favorite-option">
              <mat-icon class="favorite-icon">star</mat-icon>
              {{ option.name | translate }}
            </span>
          } @else {
            <span>{{ option.name | translate }}</span>
          }
          @if (option.optionSuffix) {
            ({{ option.optionSuffix | translate }})
          }
        </div>
      </ng-template>
      <ng-template #valueData>
        @for (option of getDisplayedOptionsForRender(); track $index) {
          <mat-option
            [value]="option.data"
            [ngClass]="option.optionClass"
            [disabled]="option.isOptionDisabled"
          >
            <ng-container
              *ngTemplateOutlet="optionTemplate; context: { option: option }"
            ></ng-container>
          </mat-option>
        }
      </ng-template>
      <ng-template #wholeObject>
        @for (option of getDisplayedOptionsForRender(); track $index) {
          <mat-option
            [value]="option"
            [ngClass]="option.optionClass"
            [disabled]="option.isOptionDisabled"
          >
            <ng-container
              *ngTemplateOutlet="optionTemplate; context: { option: option }"
            ></ng-container>
          </mat-option>
        }
      </ng-template>
      @if (!getDisplayedOptionsForRender()?.length) {
        <mat-option disabled>
          {{ 'currentlyNoDataAvailable' | translate }}
        </mat-option>
      }
    </mat-select>
    @if (!control.pristine) {
      @for (error of control.errors | errorKeys; track $index) {
        <mat-error>
          {{ messages[error] | translate }}
        </mat-error>
      }
    }
  </mat-form-field>
}
<div class="input-description">{{ description }}</div>
